import { delay } from 'redux-saga'
import { takeEvery, call, put, select } from 'redux-saga/effects'

import { Types } from './actions'

import { Services } from '../Api'

import { ApiCreators, TrackingCreators } from '../../actions'

import config from '../Config'

import isChatOnline from '../Helpers/chatOnline'

/**
 * Calls the CMC service and checks the provided availability times
 * to determine whether or not live chat is available
 *
 * @param {object} containing action type and callback function provided by parent app
 */

export function* getContactCenterStatus({ callback, brand }) {
  try {
    const result = yield call(Services.getContactCenterStatus, brand)
    const { online, openingHours } = isChatOnline(result)

    if (online) {
      yield call(callback, { online, openingHours })
      yield put(ApiCreators.contactCenterSuccess(true))
      yield put(TrackingCreators.trackAvailability(true))
    } else {
      yield call(callback, { online, openingHours })
      yield put(ApiCreators.contactCenterSuccess(false))
      yield put(TrackingCreators.trackAvailability(false))
    }
  } catch (exception) {
    yield put(ApiCreators.contactCenterRetry(callback, brand))
  }
}

/**
 * Retries requests to check if current time is within contact center opening hours
 *
 * @param {object} containing action type and callback function provided by parent app
 */

export function* retryContactCenterStatus({ callback, brand }) {
  const {
    Api: { contactCenterRetryAttempts },
  } = yield select()

  yield delay(config.apiRetryTimeout)

  if (contactCenterRetryAttempts <= config.maxApiRetryAttempts) {
    yield put(ApiCreators.contactCenterAttempt(callback, brand))
  } else {
    callback({ online: false, error: true })
    yield put(ApiCreators.contactCenterFailure(config.maxApiRetryError))
    yield put(TrackingCreators.trackAvailability(false))
  }
}

export default [
  takeEvery(Types.CONTACT_CENTER_ATTEMPT, getContactCenterStatus),
  takeEvery(Types.CONTACT_CENTER_RETRY, retryContactCenterStatus),
]
